import React, { PropTypes, Component } from 'react'
import SuggestionItem from '../SuggestionItem'
import styles from '../../AutoCompleteInput.scss'
import classnames from 'classnames'

class Suggestions extends Component {

  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    selectedIndex: PropTypes.number.isRequired,
    show: PropTypes.bool,
    suggestions: PropTypes.array.isRequired,
  }

  static defaultProps = {
    show: false,
  }

  _handleClick = (tag) => {
    this.props.handleClick(tag)
  }

  suggestionList = () => {
    const {
      selectedIndex,
      suggestions,
      show,
    } = this.props
    const items = suggestions.map((item, i) => {
      const active = (i === selectedIndex)
      return (
        <SuggestionItem
          active={active}
          handleClick={this._handleClick}
          key={i}
          label={item.label}
          value={item.value}
        />
      )
    })

    if (!show) {
      return null
    }

    if (items.length === 0) {
      return (
        <div
          className={styles.noOption}
        >
          <span className={styles.optionText}>No results found</span>
        </div>
      )
    }

    return items
  }

  render() {
    const { show } = this.props
    const classes = {
      [styles.showing]: show,
    }

    return (
      <div className={classnames(styles.suggestions, classes)} ref="menu">
        <ul>{this.suggestionList()}</ul>
      </div>
    )
  }
}

export default Suggestions



// WEBPACK FOOTER //
// ./src/components/Form/components/AutoCompleteInput/components/Suggestions/Suggestions.js